<template>
    <information-content @redirect='redirectHome'>
        <template slot='title'>
            Maintenance en cours...<br>
            Merci de votre compréhension.
        </template>
        <template slot='label'>
            ACTUALISER
        </template>
    </information-content>
</template>

<script>
    import InformationContent from '../../components/layout/InformationContent';

    export default {
        components: {
            InformationContent},
        name: 'code503',
        methods: {
            redirectHome: function (event) {
                this.$router.push({name: 'base'});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/response/Code503.vue